<template>
  <div class="kpi-home-page" v-if="true">
    <div class="head">
      <div class="top-img">
        <img src="https://j.weizan.cn/youxiang/images/kpi_home_img.jpg" alt />
      </div>

      <div class="user">
        <div class="info bottom-line">
          <div class="top">
            <img :src="kpiUserAvatar" />
            <div class="info-value">
              <div class="activity-name two-nowrap">{{ activityName }}</div>
              <div class="user-name">
                <div class="one-nowrap">
                  <span class="brand-name" v-if="true">{{ kpiRealName }}</span>
                  {{ kpiUserMobile }}
                </div>
                <div
                  class="info-right"
                  @click="changeActivity"
                  v-if="kpiUserType == 'act'"
                >
                  切换活动
                  <van-icon v-show="true" name="play" />
                  <van-icon v-show="false" name="play" class="show-icon" />
                </div>
              </div>
              <div class="user-name mt5">
                <div class="one-nowrap">
                  <span class="brand-name" v-if="kpiUserType == 'act'"
                    >角色：活动负责人</span
                  >
                  <span class="brand-name" v-if="kpiUserType == 'brand'"
                    >角色：品牌负责人</span
                  >
                  <span class="brand-name" v-if="kpiUserType == 'staff'"
                    >角色：导购员</span
                  >
                </div>
                <div class="info-right" @click="refreshUserInfo">
                  <van-button size="mini" plain type="info"
                    >信息更新</van-button
                  >
                </div>
              </div>
              <div class="user-name">
                <div class="one-nowrap">
                  <span
                    class="brand-name"
                    v-if="kpiUserBrandName && kpiUserBrandName != 'null'"
                    >品牌：{{ kpiUserBrandName }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="reward-group">
          <div>
            <div class="number">
              <span>{{ KpiUserAccount.totalMoney }}</span>
            </div>
            <div class="word">奖励总金额</div>
          </div>
          <div>
            <div class="number sign">
              <span>{{ KpiUserAccount.withdrawnMoney }}</span>
            </div>
            <div class="word">已提取金额</div>
          </div>
          <div>
            <div class="number">
              <span>{{ KpiUserAccount.availableMoney }}</span>
            </div>
            <div class="word">剩余金额</div>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="handle-group group">
        <div class="tip cz">我的操作</div>
        <div class="handle-group-item small">
          <!-- 旧版是跳转路由，新版直接弹出框显示即可 -->
          <!-- 需要修改 -->
          <div
            @click="openPoster('promotion', 'promotion_poster')"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-poster"></i>
            <div>推广海报</div>
          </div>
          <div
            @click="openPoster('live', 'live_invite')"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-live"></i>
            <div>直播邀请</div>
          </div>
          <router-link
            :to="{ path: '/kpi/ordercancel', query: { act_id: act_id } }"
          >
            <i class="icon-scan"></i>
            <div>扫码核销</div>
          </router-link>
          <div @click="openActSign" style="width: 25%; margin-top: 20px">
            <i class="icon-code"></i>
            <div v-if="kpiUserType == 'act'">活动签到</div>
            <div v-else>逛店签到</div>
          </div>
        </div>
        <div class="handle-group-item small" v-if="kpiUserType == 'act'">
          <router-link
            :to="{ path: '/kpi/pay', query: { act_id: act_id } }"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-pay"></i>
            <div>活动支出</div>
          </router-link>
          <router-link
            :to="{ path: '/kpi/datachart', query: { act_id: act_id } }"
          >
            <i class="icon-appoint"></i>
            <div>活动数据</div>
          </router-link>
        </div>
        <div class="handle-group-item small" v-if="kpiUserType == 'brand'">
          <router-link
            :to="{ path: '/kpi/managersrecharge', query: { act_id: act_id } }"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-pay"></i>
            <div>充值管理</div>
          </router-link>
        </div>
      </div>
      <div
        class="handle-group group"
        v-if="kpiUserType == 'act' || kpiUserType == 'brand'"
      >
        <div class="tip cz">人员管理</div>
        <div class="handle-group-item small">
          <div
            @click="openPoster('kpi_user', '')"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-invite"></i>
            <div>邀请导购员</div>
          </div>
          <router-link
            :to="{ path: '/kpi/examine', query: { act_id: act_id } }"
            style="width: 25%; margin-top: 20px"
            v-if="kpiUserType == 'act'"
          >
            <i class="icon-examine"></i>
            <div>人员审核</div>
          </router-link>
          <!-- <div @click="showQr=true" style="width: 25%;margin-top: 20px;">
            <i class="icon-appoint"></i>
            <div>邀请品牌负责人</div>
          </div>-->
        </div>
      </div>

      <div class="handle-group group" v-if="kpiUserType == 'act'">
        <div class="tip cz">任务管理</div>
        <div class="handle-group-item small">
          <router-link
            :to="{ path: '/kpi/bonuspool', query: { act_id: act_id } }"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-pool"></i>
            <div>奖金池任务</div>
          </router-link>
          <router-link
            :to="{ path: '/kpi/punish', query: { act_id: act_id } }"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-punish"></i>
            <div>品牌惩罚任务</div>
          </router-link>
          <router-link
            :to="{ path: '/kpi/handpunish', query: { act_id: act_id } }"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-hand"></i>
            <div>品牌手动奖惩</div>
          </router-link>
          <router-link
            :to="{ path: '/kpi/ownerquery', query: { act_id: act_id } }"
            style="width: 25%; margin-top: 20px"
          >
            <i class="icon-owner"></i>
            <div>业主查询</div>
          </router-link>
        </div>
      </div>

      <div
        class="task-group group"
        v-if="
          (kpiUserType == 'staff' || kpiUserType == 'brand') &&
          TaskList.length > 0
        "
      >
        <div class="tip bottom-line">我的任务</div>
        <div v-for="(task, index) in TaskList" :key="index">
          <div class="item bottom-line" clickable>
            <div class="detail">
              <img src="https://j.weizan.cn/youxiang/images/task_img.png" alt />
              <div class="task-info">
                <span class="first">
                  <span class="task-name">{{ task.name }}</span>
                  <span class="font done" v-if="task.status">(已完成)</span>
                  <span class="font do" v-else>(未完成)</span>
                </span>

                <span>
                  <span class="task-time">开始</span>
                  {{ task.startTime }}
                </span>
                <span>
                  <span class="task-time">结束</span>
                  {{ task.finishTime }}
                </span>
              </div>
            </div>
            <div class="btn" v-if="false">
              <van-button size="small" round type="info" v-show="true"
                >展开</van-button
              >
              <van-button size="small" round type="info" v-show="false"
                >收起</van-button
              >
            </div>
            <div class="btn" v-if="true">
              <!-- <van-button
                size="small"
                round
                class="progress"
                @click="progress(task)"
                v-if="true"
              >查看进度</van-button>-->
              <van-button
                size="small"
                round
                class="progress"
                @click="editStage(task.id)"
                >任务进度</van-button
              >
              <van-button
                size="small"
                round
                type="info"
                v-show="index !== curId"
                @click="open(task, index)"
                >任务展开</van-button
              >
              <van-button
                size="small"
                round
                type="info"
                v-show="index == curId"
                @click="close"
                >任务收起</van-button
              >
            </div>
          </div>
          <div
            v-if="
              index === curId && task.staffStepVO && task.staffStepFinishDataVO
            "
            class="achieve bottom-line"
          >
            <div class="out">
              <div class="in">
                <div>浏览</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.viewNum }}</span>
                  / {{ task.staffStepVO.viewNum }}
                </div>
              </div>
              <div class="in">
                <div>裂变</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.fissionNum }}</span>
                  / {{ task.staffStepVO.fissionNum }}
                </div>
              </div>
            </div>
            <div class="out">
              <div class="in">
                <div>报名</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.enrollmentNum }}</span>
                  / {{ task.staffStepVO.enrollmentNum }}
                </div>
              </div>
              <div class="in">
                <div>售券</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.cardNum }}</span>
                  / {{ task.staffStepVO.cardNum }}
                </div>
              </div>
            </div>
            <div class="out">
              <div class="in">
                <div>秒杀</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.seckillUserNum }}</span>
                  / {{ task.staffStepVO.seckillUserNum }}
                </div>
              </div>
              <div class="in">
                <div>集赞</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.thumbNum }}</span>
                  / {{ task.staffStepVO.thumbNum }}
                </div>
              </div>
            </div>
            <div class="out">
              <div class="in">
                <div>进入直播间</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.liveViewNum }}</span>
                  / {{ task.staffStepVO.liveViewNum }}
                </div>
              </div>
              <div class="in">
                <div>直播下订</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.liveOrderCusNum }}</span>
                  / {{ task.staffStepVO.liveOrderCusNum }}
                </div>
              </div>
            </div>
            <div class="out">
              <div class="in">
                <div>直播自签单</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.liveSelfOrderNum }}</span>
                  / {{ task.staffStepVO.liveSelfOrderNum }}
                </div>
              </div>
              <div class="in">
                <div>直播贡献单</div>
                <div>
                  <span>{{
                    task.staffStepFinishDataVO.liveOtherOrderNum
                  }}</span>
                  / {{ task.staffStepVO.liveOtherOrderNum }}
                </div>
              </div>
            </div>
            <div class="out">
              <div class="in">
                <div>直播自签转单</div>
                <div>
                  <span>{{
                    task.staffStepFinishDataVO.liveSelfOrderChangeNum
                  }}</span>
                  / {{ task.staffStepVO.liveSelfOrderChangeNum }}
                </div>
              </div>
              <div class="in">
                <div>直播贡献转单</div>
                <div>
                  <span>{{
                    task.staffStepFinishDataVO.liveOtherOrderChangeNum
                  }}</span>
                  / {{ task.staffStepVO.liveOtherOrderChangeNum }}
                </div>
              </div>
            </div>
            <div class="out">
              <div class="in">
                <div>过程自签单</div>
                <div>
                  <span>{{
                    task.staffStepFinishDataVO.processSelfOrderNum
                  }}</span>
                  / {{ task.staffStepVO.processSelfOrderNum }}
                </div>
              </div>
              <div class="in">
                <div>过程贡献单</div>
                <div>
                  <span>{{
                    task.staffStepFinishDataVO.processDevoteOrderNum
                  }}</span>
                  / {{ task.staffStepVO.processDevoteOrderNum }}
                </div>
              </div>
            </div>
            <div class="out">
              <div class="in">
                <div>直播预约</div>
                <div>
                  <span>{{ task.staffStepFinishDataVO.appointmentNum}}</span>/ {{ task.staffStepVO.appointmentNum }}
                </div>
              </div>
              <div class="in">
              </div>
            </div>
          </div>

          <div
            class="my-bean group"
            v-if="kpiUserType !== 'act' && index === curId && stage"
          >
            <div class="tip">我的本阶段奖励豆</div>
            <div class="f Flex-between">
              <!-- <div class="bean f Flex-between">
                <div>品牌奖金池总额</div>
                <div class="bean-num">暂无</div>
              </div>-->
              <div class="bean f Flex-between">
                <div>我的奖励豆</div>
                <div class="bean-num">{{ BeanDetail.totalBeanNums || 0 }}</div>
              </div>
              <div class="bean f Flex-between">
                <div>导购员奖金池总额</div>
                <div class="bean-num">{{ stage.totalBonusPool || 0 }}</div>
              </div>
            </div>
            <div class="f flex-between">
              <div class="bean f Flex-between">
                <div>奖励豆总数</div>
                <div class="bean-num">{{ stage.totalBean || 0 }}</div>
              </div>
              <div class="bean f Flex-between">
                <div>达标奖励豆总数</div>
                <div class="bean-num">{{ stage.actualTotalBean || 0 }}</div>
              </div>
            </div>
            <div class="f flex-between">
              <div class="bean f Flex-between">
                <div>当前虚拟豆值</div>
                <div class="bean-num">{{ stage.fictitiousBean || 0 }}</div>
              </div>
              <div class="bean f Flex-between">
                <div>阶段实际豆值</div>
                <div class="bean-num">{{ stage.actualBean || 0 }}</div>
              </div>
            </div>
            <div class="f flex-between">
              <!-- <div class="bean f Flex-between">
                <div>我的奖励豆</div>
                <div class="bean-num">{{BeanDetail.totalBeanNums||0}}</div>
              </div>-->
              <div class="bean f Flex-between">
                <div>预计收入</div>
                <div class="bean-num">{{ BeanDetail.estimateIncome || 0 }}</div>
              </div>
              <div class="bean f Flex-between">
                <div>实际收入</div>
                <div class="bean-num">{{ BeanDetail.realIncome || 0 }}</div>
              </div>
            </div>
            <!-- <div class="f flex-between">
              <div class="bean f Flex-between">
                <div>实际收入</div>
                <div class="bean-num">{{BeanDetail.realIncome||0}}</div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <!--业主签到二维码-->
    <van-popup v-model="sign_show" class="sign-show">
      <img
        src="https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/test/upload/image/2020/07/20/931a0a6c222b443c855bcd5d1c092998.jpg"
        alt
      />
    </van-popup>
    <!-- 查看推广海报内容旧版 -->
    <!-- <van-popup v-model="showPosterQr" class="award">
      <div class="box">
        <img id="canvas-pic" v-if="canvasFlag" :src="PosterPic" />
      </div>
      <div @click.stop="showPosterQr = false" class="close">
        <van-icon name="close" />
      </div>
    </van-popup> -->
    <!-- 新版海报隐藏页推广 -->
    <div id="capture2" ref="poster2">
      <div class="bottom_detail fvc fbt">
        <div class="f">
          <img
            class="useravatar"
            :src="kpiUserAvatar"
            crossorigin="anonymous"
            alt="图片加载中，请稍后"
          />
          <div class="title ml10 f v frd">
            <div class="fw600">{{ kpiRealName || "优想家居" }}邀请您</div>
            <div class="fw600" v-if="postType == 'inviteUser'">
              一起参加活动
            </div>
            <div class="fw600" v-if="postType == 'live'">一起来看直播</div>
            <div class="fw600" v-if="postType == 'staff'">加入活动团队</div>
            <div class="tocode mt5">长按识别二维码 ></div>
          </div>
        </div>
        <img
          class="qrcode"
          :src="QrCode"
          crossorigin="anonymous"
          alt="图片加载中，请稍后"
        />
      </div>
      <img
        :src="
          PosterPic
            ? PosterPic
            : 'https://j.weizan.cn/youxiang/default-poster-bg.png'
        "
        id="posterDOM"
        crossorigin="anonymous"
        class="bgposter"
        alt="图片加载中，请稍后"
      />
    </div>
    <!-- 新版海报隐藏页直播 -->
    <div id="capture3" ref="poster3">
      <div class="bottom_detail f v">
        <div class="fvc f12 fw600">
          <div>您的好友</div>
          <img
            class="useravatar"
            :src="kpiUserAvatar"
            crossorigin="anonymous"
            alt="图片加载中，请稍后"
          />
          <div>邀请您一起来看直播</div>
        </div>
        <img
          class="qrcode"
          :src="QrCode"
          crossorigin="anonymous"
          alt="图片加载中，请稍后"
        />
        <div class="tocode">长按识别二维码</div>
      </div>
      <img
        :src="
          PosterPic
            ? PosterPic
            : 'https://j.weizan.cn/youxiang/default-poster-bg.png'
        "
        id="posterDOM"
        crossorigin="anonymous"
        class="bgposter"
        alt="图片加载中，请稍后"
      />
    </div>
    <!-- 查看推广海报内容New版 -->
    <van-dialog
      v-model="showPosterQr"
      confirmButtonText="关闭"
      @confirm="showPosterQr = false"
      :close-on-click-overlay="false"
    >
      <div class="box">
        <!-- <div>1</div> -->
        <!-- 注释文本 -->
        <img id="canvas-pic" v-if="canvasFlag" :src="PosterPic" />
      </div>
    </van-dialog>
    <!--活动切换-->
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        title="切换活动"
        :columns="columns"
        @cancel="show = !show"
        value-key="actName"
        @confirm="changeAct"
      />
    </van-popup>
    <!-- 签到二维码 -->
    <van-dialog
      v-model="showactsign"
      confirmButtonText="刷新"
      @confirm="refreshQrCode"
      @close="clearTime"
      :close-on-click-overlay="true"
    >
      <div style="width: 80%; margin: 10px auto">
        <img
          :src="ActSignQrCode"
          style="width: 100%"
          alt="图片加载中，请稍后"
        />
        <div style="text-align: center">签到码30秒内有效</div>
        <div style="text-align: center">扫码签到后自动刷新</div>
      </div>
    </van-dialog>
    <!-- 关注公众号二维码 -->
    <van-dialog
      v-model="showNewUserInfo"
      confirmButtonText="关闭"
      :close-on-click-overlay="true"
    >
      <div style="width: 80%; margin: 10px auto">
        <img
          :src="UserSignQrCode"
          style="width: 100%"
          alt="图片加载中，请稍后"
        />
        <div style="text-align: center">更新信息需先关注优想公众号</div>
        <div style="text-align: center" class="mt5">请长按二维码前往关注</div>
      </div>
    </van-dialog>
    <!--奖励政策-->
    <van-popup v-model="showaward" class="award">
      <img src="https://j.weizan.cn/youxiang/images/awrad_img.jpg" />
      <div class="treaty">
        <div v-html="kpiRewardRule ? kpiRewardRule : '暂无内容'"></div>
      </div>
      <div @click="closeAward" class="close">
        <van-icon name="close" />
      </div>
    </van-popup>
    <!-- 用来合并的div旧版 -->
    <div id="capture" ref="poster">
      <div class="title">
        <div class="mt10">{{ kpiRealName || "优想家居" }}</div>
        <div class="mt5">邀请您</div>
        <div class="mt5" v-if="postType == 'inviteUser'">一起参与活动</div>
        <div class="mt5" v-if="postType == 'live'">一起来看直播</div>
        <div class="mt5" v-if="postType == 'staff'">加入活动团队</div>
      </div>
      <img class="useravatar" :src="kpiUserAvatar" crossorigin="anonymous" alt="图片加载中，请稍后" />
      <img
        class="qrcode"
        :src="QrCode"
        crossorigin="anonymous"
        alt="图片加载中，请稍后"
      />
      <img
        :src="
          PosterPic
            ? PosterPic
            : 'https://j.weizan.cn/youxiang/default-poster-bg.png'
        "
        id="posterDOM"
        crossorigin="anonymous"
        class="bgposter"
        alt="图片加载中，请稍后"
      />
    </div>
    <!-- 分享二维码海报生成失败的二维码弹窗 -->
    <van-dialog
      v-model="showfailcode"
      confirmButtonText="关闭"
      @confirm="showfailcode = false"
      :close-on-click-overlay="false"
    >
      <div style="width: 80%; margin: 10px auto">
        <img
          :src="QrCodeAddress"
          style="width: 100%"
          alt="图片加载中，请稍后"
        />
        <div style="text-align: center">海报生成出了点差错</div>
        <div style="text-align: center">请长按推广二维码暂时保存</div>
      </div>
    </van-dialog>
    <app-footer></app-footer>
    <div style="display: none;">
      <div id="qrcode-simple"></div>
    </div>
  </div>
</template>


<script>
import appFooter from "../../components/app-footer";
import html2canvas from "html2canvas";
import utils from "../../utils/utils";
export default {
  components: {
    appFooter,
  },
  data() {
    return {
      act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      posterFlag: true, // 控制html元素
      canvasFlag: false, //控制canvas元素
      showaward: false,
      kpiRewardRule: "",
      showactsign: false,
      showNewUserInfo: false,
      columns: ["全部"],
      showQr: false,
      //   activity: this.settings.activity,
        // user_id: this.$route.query.user_id,
      //   kpi_uid: this.$route.query.kpi_uid,
      //   share_uid: this.$route.query.share_uid,
      user: null,
      live_user: null,
      award_show: false, // 奖励政策
      sign_show: false, // 业主签到
      show: false, // 切换
      page: 1,
      flag: false,
      stages: [],
      stage: null, // 单个未完成的阶段数据
      down_time: [], // 未完成任务
      times: [], // 倒计时
      qrcode: null,
      sign_qrcode: null,
      curId: null, //展开的我的任务Id
      roles: [],
      role: null,
      radio: null,

      // 7.23接口联调参数
      activityName: "",
      kpiUserName: "",
      kpiUserAvatar: "https://j.weizan.cn/city/app/default-pic500.png",
      kpiUserType: "act",
      userType: "act",
      KpiUserAccount: {
        total: 0,
        withdraw: 0,
        avaliable: 0,
      },
      TaskDetail: {},
      TaskList: [],
      BeanDetail: {},
      BeanDetailVO: {},
      showPosterQr: false,
      PosterPic: "",
      QrCode: "",
      ActSignQrCode: "",
      UserSignQrCode: "",
      postType: "",
      kpiRealName: "",
      kpiUserMobile: "",
      brandId: 0,
      shopId: 0,
      kpiUserId: 0,
      userId: 0,
      BrandList: [],
      kpiUserBrandName: "",
      showfailcode: false,
      QrCodeAddress: "",
      showNewPoster: true,
      QrCodeTimer:null,
    };
  },
  methods: {
    async getActInfo() {
      let res = await this.$http.post("/v1/home/activity");
      console.log(res);
      this.activityName = res.data.actName;
    },
    async changeActivity() {
      let res = await this.$http.post("/v1/kpiuser/all_act");
      console.log(res);
      if (res.code == 0 || res.code == 10200) {
        this.columns = res.code == 0 ? res.data : this.columns;
        this.show = true;
      }
    },
    // 获取奖励金额和提现金额信息
    async getKpiUserAccount() {
      let res = await this.$http.post("/v1/finance/query_kpi_user_finance");
      console.log(res);
      if (res.data) {
        this.KpiUserAccount = res.data;
      }
    },
    // 查询我的本阶段奖励豆
    async getMyTaskBeanDetail(stepId) {
      let res = await this.$http.post(
        `/v1/kpiuser/my_step_reward?stepId=${stepId}`
      );
      console.log(res);
      this.BeanDetail = {};
      this.BeanDetailVO = {};
      if (res.data && res.code == 0) {
        if (res.data.stepVO) {
          this.BeanDetailVO = res.data.stepVO;
          this.BeanDetail = res.data;
        }
      }
    },
    // 查询我的任务列表
    async getMyTask() {
      let res = await this.$http.post("/v1/kpiuser/my_task");
      console.log(res);
      this.TaskList = [];
      if (res.data && res.code == 0) {
        // 若已完成则不显示
        this.TaskList = res.data.list;
      }
    },
    // 打开我的任务详情
    async open(task, index) {
      this.curId = index;
      // 此时请求单step的奖励豆数据
      await this.getMyTaskBeanDetail(task.id);
      // this.stage = task;
      this.stage = this.BeanDetailVO;
    },
    close() {
      this.curId = null;
      this.stage = null;
    },
    // 打开推广/邀请海报页面
    async openPoster(type, typeposter) {
      this.PosterPic = "";
      this.$store.commit("setLoading", true);
      this.posterFlag = true; // 控制html元素
      this.canvasFlag = false; //控制canvas元素
      // 调用海报背景图加载，
      let res = await this.$http.post(`/v1/kpiuser/poster?type=${type}`);
      console.log(res);
      if (res.data && res.code == 0) {
        this.PosterPic = res.data.pic;
      } else {
        this.$store.commit("setLoading", false);
        return;
      }
      // 调用二维码生成加载，邀请注册kpi另外获取
      if (this.kpiUserType == "act" && !typeposter) {
        typeposter = "invite_kpi_user_brand";
        this.postType = "staff";
        // 请求品牌列表
        await this.getBrandList();
        if (this.BrandList.length == 0) {
          this.$toast("请先在后台创建品牌门店后再邀请品牌负责人和导购员");
          this.$store.commit("setLoading", false);
          return;
        }
      } else if (this.kpiUserType == "brand" && !typeposter) {
        typeposter = "invite_kpi_user_staff";
        this.postType = "staff";
      }
      // 切换海报文案
      if (type == "promotion") {
        this.postType = "inviteUser";
      } else if (type == "live") {
        this.postType = "live";
      }
      // else {
      //   this.$toast("非活动负责人及品牌负责人无法推广");
      //   that.$store.commit("setLoading", false);
      //   return;
      // }
      let tmp = document.getElementById("posterDOM");
      tmp.onload = () => {
        console.log("1-in");
        let base64 = this.getBase64Image(tmp);
        this.PosterPic = base64;
      };
      let qrres = await this.$http.get("/v1/qrcode/gen_code", {
        scene: typeposter,
      });

      // 第一个参数 场景，第二个actId（活动id）第三个 kpiuserId(kpi)第四个分享用户id
      // type: kpi_user
      // typeposter
      let sceneValue = 0;
      if (type == 'kpi_user') {
        if (this.kpiUserType == 'act') {
          sceneValue = 5 // 邀请品牌负责人
        } else if (this.kpiUserType == 'brand') {
          sceneValue = 4 // 邀请导购员
        } else {
          sceneValue = 5 // 邀请品牌负责人
        }
      } else if (type == 'promotion') {
        sceneValue = 1
      }
      if (sceneValue != 0) {
        const codeUrl = `${location.origin}/wx/v1/qrcode/url/${sceneValue},${this.act_id},${this.kpiUserId},${this.userId}`
        $('#qrcode-simple').qrcode({
          text: codeUrl,
          height: 350,
          width: 350
        })
        await utils.sleep(800)
        var newcodeurl = ''
        try {
          newcodeurl = $('#qrcode-simple').find('canvas').get(0).toDataURL('png', 0.6)
        } catch (error) {
          newcodeurl = ''
        }
        newcodeurl && (qrres.data.qrcodeBase64 = newcodeurl)
      }

      console.log(qrres);
      if (qrres.data && qrres.code == 0) {
        this.QrCode = qrres.data.qrcodeBase64;
        this.QrCodeAddress = qrres.data.qrcodePath;
        // 二维码获取完毕，进行拼接
        this.$toast("海报生成中，请稍后");
        setTimeout(() => {
          console.log("success");
          window.pageYOffset = 0;
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          this.createCanvas(type);
        }, 500);
        setTimeout(() => {
          console.log("fail");
          // 10秒后若无生成背景图且有二维码的情况下
          if (!this.canvasFlag && !this.showPosterQr && this.QrCode) {
            this.showPosterQr = false;
            this.showfailcode = true;
            this.$store.commit("setLoading", false);
          }
        }, 10000);
      } else {
        this.$toast(qrres.msg);
        this.$store.commit("setLoading", false);
        return;
      }
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = 1050;
      canvas.height = 1866;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, 1050, 1866);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },
    createCanvas(type) {
      const that = this;
      var posterdom = this.$refs.poster2;
      if (type == "live") {
        posterdom = this.$refs.poster3;
      }
      html2canvas(posterdom, {
        useCORS: true,
        // width: 320, // 绘制图片的宽 2倍
        // dpi: window.devicePixelRatio * 2, // dpi  如果模糊的话 就把dpi和scale缩放的值调大 dpi越高生成的图片越大
        // height: 568, // 绘制图片的高 2倍
        scale: 3,
      })
        .then(function (canvas) {
          setTimeout(() => {
            that.PosterPic = canvas.toDataURL("image/jpg");
            that.canvasFlag = true;
            that.showPosterQr = true;
            that.$store.commit("setLoading", false);
          });
        })
        .catch((e) => {
          that.$store.commit("setLoading", false);
          console.log(e);
        });
    },
    // 打开扫码签到页面
    async openActSign() {
      this.$store.commit("setLoading", true);
      let isGoShop = await this.getShopVisitedData();
      if (!isGoShop && this.kpiUserType != "act") {
        this.$toast("抱歉，当前品牌未参与逛店活动");
        this.$store.commit("setLoading", false);
        return;
      }
      let qrres = await this.$http.get("/v1/qrcode/gen_code", {
        scene: this.kpiUserType == "act" ? "act_sign" : "go_shop_sign",
        addition: encodeURIComponent(
          JSON.stringify({
            brandId: this.brandId,
            shopId: this.shopId,
            // kpiUserId: this.kpiUserId,
          })
        ),
      });
      console.log(qrres);
      if (qrres.data && qrres.code == 0) {
        this.ActSignQrCode = qrres.data.qrcodeBase64;
        this.$store.commit("setLoading", false);
        this.showactsign = true;
        // 执行30秒刷新一次
        // this.QrCodeTimer && clearInterval(this.QrCodeTimer);
        // this.QrCodeTimer = setInterval(() => {
        //     this.openActSign();
        // }, 30000);
        this.QrCodeTimer && clearTimeout(this.QrCodeTimer);
        this.QrCodeTimer = setTimeout(() => {
          this.openActSign();
        }, 30000);
      } else {
        this.$store.commit("setLoading", false);
        this.$toast(qrres.msg);
      }
    },
    // 刷新签到二维码
    refreshQrCode() {
      this.openActSign();
    },
    clearTime() {
      this.QrCodeTimer && clearTimeout(this.QrCodeTimer);
    },
    // 获取奖励规则
    async getQueryStepDetails() {
      let res = await this.$http.post(
        `/v1/taskmanage/query_bonus_setting_detail`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.kpiRewardRule = res.data.actKpiVO.rewardRule;
        this.showaward = true;
      }
    },
    async getBrandList() {
      var actId = localStorage.getItem("act_id");
      let res = await this.$http.post(`/v1/taskmanage/list`, {
        actId: actId,
        catId: "",
        name: "",
        page: 1,
        size: 1000,
      });
      console.log(res);
      if (res.data && res.code == 0) {
        this.BrandList = res.data.list;
      }
    },
    async getShopVisitedData() {
      let res = await this.$http.post(`/v1/finance/config/go_shop_list`);
      console.log(res);
      if (res.data && res.code == 0) {
        let list = res.data;
        var index = list.findIndex((item) => this.brandId == item.brandId);
        if (index == -1) {
          return false;
        } else {
          return true;
        }
      } else {
        this.$toast(res.msg);
        return false;
      }
    },
    closeAward() {
      localStorage.setExpire("closeaward", "closeaward", 15 * 60 * 60 * 1000);
      console.log(localStorage.getExpire("isremember"), "yes");
      this.showaward = false;
    },
    // 切换活动
    changeAct(value) {
      console.log(value);
      localStorage.setItem("act_id", value.id);
      this.show = false;
      location.assign(`/kpi?act_id=${value.id}`);
      //重新加载页面
      // this.getKpiUserAccount();
      // window.location.reload();
    },
    // 9.21品牌负责人和导购员也可以查看阶段任务情况
    editStage(stepId) {
      this.$router.push({
        name: "kpi-progress",
        query: {
          step_id: stepId,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    // 11.16修改
    async refreshUserInfo() {
      var openId = localStorage.getItem("openid");
      let res = await this.$http.post(`/v1/kpiuser/refresh_user_info`, {
        openId: openId,
      });
      console.log(res);
      if (res.code == 20305) {
        return this.$dialog.confirm({
          title: '提示',
          message: res.msg,
        })
          .then(() => {
            this.$router.replace('/login')
          })
          .catch(() => {});
      }
      if (res.data && res.code == 0) {
        if (res.data.subscribe == 1) {
          // this.kpiRealName = res.data.nickName||"用户名";
          this.kpiUserAvatar =
            res.data.avatar ||
            "https://j.weizan.cn/city/app/default-pic500.png";
          this.$toast("头像信息更新成功~！");
        } else if (res.data.subscribe == 0) {
          this.UserSignQrCode = res.data.mqQrCode;
          this.showNewUserInfo = true;
        }
      } else {
        this.$toast(res.msg);
      }
    },
  },
  created() {
    console.log("2021.9.29.1");
    this.act_id = this.$route.query.act_id || localStorage.getItem("act_id");
    if (localStorage.getExpire("closeaward") == null) {
      this.getQueryStepDetails();
    }
    this.kpiUserBrandName = localStorage.getItem("kpiBrandName");
    // 本地开发不显示（需wx登录获取下面的值
    // 本地开发要去微信环境拿token和user_id、act_id存入local
    if (process.env.NODE_ENV === "production") {
      this.kpiUserName = localStorage.getItem("userName");
      // this.kpiUserMobile = localStorage.getItem("userMobile");
      this.kpiUserAvatar = localStorage.getItem("avatarUrl");
      this.kpiUserType = localStorage.getItem("userType");
      this.userType = localStorage.getItem("userType");
      this.kpiRealName = localStorage.getItem("kpiRealName");
      this.kpiUserBrandName = localStorage.getItem("kpiBrandName");
      this.kpiUserMobile = localStorage.getItem("kpiUserMobile");
      this.brandId = localStorage.getItem("brand_id");
      this.shopId = localStorage.getItem("shop_id");
      this.kpiUserId = localStorage.getItem("kpi_user_id");
      this.userId = localStorage.getItem("user_id");
    }
    if (this.kpiUserType == "brand" || this.kpiUserType == "staff") {
      this.getMyTask();
    }

    this.getActInfo();
    this.getKpiUserAccount();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
};
</script>

<style lang="less" scoped>
// @import "../../assets/less/common.less";
// @import "../../assets/less/reset.less";
.van-dialog {
  top: 50%;
}
.kpi-home-page {
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
  font-size: 14px;
  ::v-deep .van-dialog__content, .van-dialog {
    width: 250px;
  }
  .box {
    position: relative;
    margin: 5px auto;
    height: auto;
    #canvas-pic {
      width: 234px;
      border-radius: 5px;
    }
  }

  .head {
    background-color: #ffffff;
    position: relative;
    height: 224px;
    .top-img {
      position: absolute;
      width: 100%;
      height: 150px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .user {
      position: absolute;
      border-radius: 4px;
      background-color: #ffffff;
      bottom: 15px;
      left: 15px;
      right: 15px;
      box-shadow: #e2e4e2 0px 6px 8px -2px; //边框阴影
      .info {
        padding: 20px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .top {
          display: flex;
          align-items: center;
          width: 100%;
          overflow: hidden;
          img {
            // 用户头像
            min-width: 50px;
            max-width: 50px;
            height: 50px;
            border-radius: 50%;
          }
          .info-value {
            margin-left: 10px;
            width: 100%;
            line-height: 24px;
            .activity-name {
              font-weight: bold;
            }
            .brand-name {
              margin-right: 5px;
            }
            .user-name {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .nowrap {
                width: 80%;
              }
            }
          }
        }
        .info-right {
          /*切换*/
          color: #999999;
          display: flex;
          align-items: center;
          margin-right: 10px;
          font-size: 12px;
          min-width: 40px;
          .van-icon {
            transform: rotate(90deg);
            -ms-transform: rotate(90deg); /* IE 9 */
            -moz-transform: rotate(90deg); /* Firefox */
            -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
            -o-transform: rotate(90deg);
            font-size: 18px;
            position: relative;
            width: 12px;
            left: 4px;
            top: -4px;
          }
          .show-icon {
            transform: rotate(-90deg);
            -ms-transform: rotate(-90deg); /* IE 9 */
            -moz-transform: rotate(-90deg); /* Firefox */
            -webkit-transform: rotate(-90deg); /* Safari 和 Chrome */
            -o-transform: rotate(-90deg);
            top: 4px;
            left: 4px;
          }
        }
      }

      .reward-group {
        /*金额*/
        background-color: #ffffff;
        padding: 15px 0;
        text-align: center;
        display: flex;
        justify-content: space-around;
        align-items: center;
        a {
          width: 33.33%;
          border-right: 1px solid #f4f4f4;
          overflow: hidden;
        }
        a:last-child {
          border: none;
        }
        .number {
          color: #3283fa;
          font-size: 20px;
        }
        .word {
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }

  .content {
    /*内容部分*/
    padding: 10px 15px;
    .group {
      padding: 15px 0 0;
      background-color: #ffffff;
      border-radius: 4px;
      margin-bottom: 10px;
    }
    .my-bean {
      /*我的本阶段奖励豆*/
      border-top: 5px solid #f8f8f8;
      border-bottom: 5px solid #f8f8f8;
      padding: 15px 10px;
      .tip {
        padding: 0 0 10px;
      }
    }
    .handle-group {
      /*操作按钮*/
      box-shadow: #e2e4e2 3px 6px 8px 2px; //边框阴影
      padding-bottom: 15px;
      .handle-group-item {
        display: flex;
        text-align: center;
        a {
          margin-top: 20px;
          width: 25%;
        }
        img {
          width: 22px;
          height: 22px;
        }
      }
      .small {
        font-size: 12px;
      }
    }
    .tip {
      font-weight: bold;
      padding: 0 10px 10px;
    }
    .cz {
      padding-bottom: 0;
    }

    .task-group {
      /*任务按钮*/
      box-shadow: #e2e4e2 3px 6px 8px 2px; //边框阴影
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        .detail {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex: 1;
          overflow: hidden;
          img {
            width: 50px;
            min-width: 50px;
            max-width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
          }
          .task-info {
            display: flex;
            flex-direction: column;
            font-size: 12px;
            flex: 1;
            overflow: hidden;
            line-height: 1.2;
            .first {
              font-size: 14px;
              margin-bottom: 3px;
            }
            .task-time {
              color: #808080;
            }
            .font {
              font-size: 13px;
              margin-left: 6px;
            }
            .task-name {
              color: #5293fd;
            }
          }
        }
        .btn {
          display: flex;
          flex-direction: column;
          .progress {
            background-color: #f58022;
            color: #ffffff;
          }
          .van-button--small {
            margin: 2px 0;
            height: 24px;
            line-height: 22px;
          }
        }
      }
      .achieve {
        padding: 5px 10px;
        .out {
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex: 1;
          font-size: 12px;
          line-height: 24px;
          .in {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: 1;
            padding: 0 10px;
            span {
              color: #5293fd;
            }
          }
        }
      }
      .bean {
        width: 50%;
        font-size: 12px;
        padding-left: 10px;
        line-height: 26px;
        box-sizing: border-box;
        .bean-num {
          color: #5293fd;
        }
      }
    }

    .time {
      /*倒计时*/
      text-align: center;
      span {
        color: #ff6903;
      }
      span:last-child {
        color: #5293fd;
      }
      .group {
        padding: 15px 0;
      }
    }
  }

  .role-pupop {
    /*活动切换弹框*/
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    .popup-content {
      width: 70%;
      background-color: #ffffff;
      border-radius: 8px;
      padding: 10px;
      .tips {
        color: #5293fd;
        padding: 5px 10px 15px;
      }
      .van-cell--clickable {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .van-cell__title {
          max-width: 90%;
        }
        .van-cell__title,
        .van-cell__value {
          flex: none;
        }
      }
    }
    .role-close {
      width: 70%;
      padding: 0 10px;
      text-align: right;
      color: #ffffff;
      font-size: 26px;
      i {
        display: initial;
      }
    }
  }

  .sign-show {
    /*业主签到弹框*/
    img {
      width: 160px;
      height: 160px;
      vertical-align: bottom;
    }
  }

  .van-popup {
    background-color: transparent;
  }
  .award {
    /*奖励规则弹框*/
    width: 70%;
    overflow: hidden;
    img {
      border-radius: 4px 4px 0 0;
      width: 100%;
      // height: 60px;
      vertical-align: bottom;
      border-radius: 4px 4px 0 0;
    }
    .treaty::-webkit-scrollbar {
      display: none;
    }
    .treatyContent::-webkit-scrollbar {
      display: none;
    }
    .treaty {
      overflow-x: hidden;
      max-height: calc(50vh);
      min-height: calc(20vh);
      background-color: #ffffff;
      border-radius: 0 0 4px 4px;
      padding: 10px;
    }
    .treaty /deep/ img {
      max-width: 100%;
    }
    .close {
      color: #ffffff;
      margin-top: 10px;
      text-align: center;
      font-size: 26px;
    }
  }
  .handle-group {
    i {
      display: block;
      position: relative;
      width: 22px;
      height: 22px;
      margin: 0 auto 5px;
    }
    .icon-poster {
      background: url("../../assets/kpi-home-img.png") no-repeat -9px -7px;
      background-size: 420px 37px;
    }
    .icon-live {
      background: url("../../assets/kpi-home-img.png") no-repeat -50px -5px;
      background-size: 420px 35px;
    }
    .icon-invite {
      background: url("../../assets/kpi-home-img.png") no-repeat -87px -6px;
      background-size: 420px 36px;
    }
    .icon-scan {
      background: url("../../assets/kpi-home-img.png") no-repeat -123px -6px;
      background-size: 420px 37px;
    }
    .icon-code {
      background: url("../../assets/kpi-home-img.png") no-repeat -159px -6px;
      background-size: 420px 37px;
    }
    .icon-pool {
      background: url("../../assets/kpi-home-img.png") no-repeat -203px -4px;
      background-size: 435px 34px;
    }
    .icon-punish {
      background: url("../../assets/kpi-home-img.png") no-repeat -239px -5px;
      background-size: 430px 35px;
    }
    .icon-hand {
      background: url("../../assets/kpi-home-img.png") no-repeat -276px -5px;
      background-size: 426px 35px;
    }
    .icon-owner {
      background: url("../../assets/kpi-home-img.png") no-repeat -338px -5px;
      background-size: 460px 36px;
    }
    .icon-examine {
      background: url("../../assets/kpi-home-img.png") no-repeat -346px -5px;
      background-size: 420px 34px;
    }
    .icon-appoint {
      background: url("../../assets/kpi-home-img.png") no-repeat -366px -4px;
      background-size: 400px 34px;
    }
    .icon-pay {
      background: url(https://j.weizan.cn/youxiang/images/activity-pay-icon.png)
        no-repeat 0 0;
      background-size: 22px 22px;
    }
  }
}
.fail-poster {
  width: 260px;
  height: 464px;
  .title {
    bottom: 15px;
    left: 50px;
    position: absolute;
    height: 50px;
    font-size: 12px;
    font-weight: 600;
    z-index: 11;
  }
  .useravatar {
    bottom: 20px;
    left: 5px;
    position: absolute;
    width: 40px;
    height: 40px;
    z-index: 11;
    border-radius: 50%;
  }
  .qrcode {
    width: 100px;
    height: 100px;
    bottom: 0px;
    right: 0px;
    position: absolute;
    z-index: 111;
  }
  .bgposter {
    width: 265px;
    height: 469px;
    top: 0px;
    left: 0px;
    position: absolute;
  }
}
#capture {
  width: 260px;
  height: 464px;
  position: fixed;
  left: 0;
  top: -9999px;
  .title {
    bottom: 15px;
    left: 55px;
    position: absolute;
    height: 50px;
    font-size: 12px;
    font-weight: 600;
    z-index: 11;
    text-align: center;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 0.6);
  }
  .useravatar {
    bottom: 20px;
    left: 10px;
    position: absolute;
    width: 40px;
    height: 40px;
    z-index: 11;
    border-radius: 50%;
  }
  .qrcode {
    width: 100px;
    height: 100px;
    bottom: 5px;
    right: 5px;
    position: absolute;
    z-index: 111;
    background-color: #ffffff;
    padding: 3px;
  }
  .bgposter {
    width: 265px;
    height: 469px;
    top: 0px;
    left: 0px;
    position: absolute;
  }
}
// 0.56
#capture2 {
  width: 300px;
  height: 535px;
  position: fixed;
  left: 0;
  top: -99999px;
  // position: relative;
  margin: 5px auto;
  .bottom_detail {
    // background-color: #fff;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 11;
    padding: 10px;
    &>.f {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .title {
    height: 60px;
    font-size: 12px;
    z-index: 11;
    align-items: center;
    text-align: center;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 0.6);
  }
  .fw600 {
    font-weight: 600;
  }
  .useravatar {
    width: 60px;
    height: 60px;
    z-index: 11;
    border-radius: 50%;
  }
  .qrcode {
    width: 140px;
    height: 140px;
    z-index: 111;
    padding: 3px;
    background-color: #ffffff;
  }
  .bgposter {
    width: 300px;
    height: 535px;
    top: 0px;
    left: 0px;
    position: absolute;
  }
  .tocode {
    font-size: 10px;
    border-radius: 5px;
    padding: 2px;
  }
}
#capture3 {
  width: 300px;
  height: 535px;
  position: fixed;
  left: 0;
  top: -9999px;
  // position: relative;
  margin: 5px auto;
  padding: 10px;
  .bottom_detail {
    // background-color: #fff;
    width: 300px;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0); /* 50%为自身尺寸的一半 */
    z-index: 11;
    justify-content: space-around;
    align-items: center;
  }
  .title {
    height: 60px;
    font-size: 12px;
    z-index: 11;
    align-items: flex-start;
    text-align: left;
  }
  .fw600 {
    font-weight: 600;
  }
  .useravatar {
    width: 25px;
    height: 25px;
    z-index: 11;
    border-radius: 50%;
    margin: 0 5px;
  }
  .qrcode {
    width: 110px;
    height: 110px;
    z-index: 111;
    padding: 3px;
    background-color: #ffffff;
  }
  .bgposter {
    width: 300px;
    height: 535px;
    top: 0px;
    left: 0px;
    position: absolute;
  }
  .tocode {
    font-size: 10px;
    border-radius: 5px;
    padding: 2px;
  }
}
.touch_action {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>